// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetPortalConfigurationResponseModel {
    static getAttributeTypeMap() {
        return GetPortalConfigurationResponseModel.attributeTypeMap;
    }
}
GetPortalConfigurationResponseModel.discriminator = undefined;
GetPortalConfigurationResponseModel.additionalProperties = false;
GetPortalConfigurationResponseModel.attributeTypeMap = [
    {
        "name": "portalConfig",
        "baseName": "portalConfig",
        "type": "PorticoPortalModel"
    },
];
//# sourceMappingURL=getPortalConfigurationResponseModel.js.map